import React from 'react';
const StarFilledIcon = (props) => {
  return (
            <svg className={props.className ? props.className : "cursor"} onClick={props.handleClick} xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 33 33">
                <text id="_" data-name="★" transform="translate(0 32)" fill={props.color ? props.color : "#FF6D73"} font-size="30" font-family="SegoeUISymbol, Segoe UI Symbol"><tspan x="0" y="0">★</tspan></text>
            </svg>
  )
}

export default StarFilledIcon;